import React from 'react';
import { Calendar, Users, Gift } from 'lucide-react';
import { useScrollTrigger } from './hooks/useScrollTrigger';

const HomeSection = ({ setActiveSection }) => {
  const [titleRef, titleVisible] = useScrollTrigger();
  const [namesRef, namesVisible] = useScrollTrigger();
  const [dateRef, dateVisible] = useScrollTrigger();
  const [imageRef, imageVisible] = useScrollTrigger();
  const [textRef, textVisible] = useScrollTrigger();
  const [separatorRef, separatorVisible] = useScrollTrigger();
  const [cardsRef, cardsVisible] = useScrollTrigger();

  return (
    <div className="text-center">
      <div className="mb-20 pt-10">
        <div className="mb-12">
          <h2 
            ref={titleRef}
            className={`text-3xl font-serif font-light text-[#7A3E53] mb-8 leading-tight transition-all duration-1000 ${
              titleVisible 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-8'
            }`}
          >
          </h2> 
          <h1 
            ref={namesRef}
            className={`text-6xl md:text-7xl font-serif font-light text-[#7A3E53] mb-6 tracking-tight transition-all duration-1000 delay-200 ${
              namesVisible 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-8'
            }`}
          >
            Megan & Greg
          </h1>
          <div 
            ref={dateRef}
            className={`flex items-center justify-center gap-4 text-[#5A8E6E] transition-all duration-1000 delay-400 ${
              dateVisible 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-8'
            }`}
          >
            <Calendar size={22} className="text-[#5A8E6E]" />
            <span className="text-xl font-light tracking-wider">February 21, 2026</span>
          </div>
        </div>

        <div 
          ref={imageRef}
          className={`w-full max-w-4xl mx-auto aspect-[3024/1906] rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-700 ${
            imageVisible 
              ? 'opacity-100 translate-y-0' 
              : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: imageVisible ? '600ms' : '0ms' }}
        >
          <picture className="w-full h-full">
            <source srcSet="/assets/MeganGregCropped.webp" type="image/webp" />
            <source srcSet="/assets/MeganGregCropped.jpg" type="image/jpeg" />
            <img
              src="/assets/MeganGreg.jpg"
              alt="Megan & Greg in front of sunset"
              className="w-full h-full object-cover transition-transform duration-700 hover:brightness-110"
              style={{ imageRendering: 'high-quality' }}
              loading="lazy"
            />
          </picture>
        </div>
      </div>

      <div 
        ref={textRef}
        className={`max-w-2xl mx-auto mb-20 px-6 transition-all duration-1000 ${
          textVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
        style={{ transitionDelay: textVisible ? '200ms' : '0ms' }}
      >
        <h2 className="text-3xl font-serif font-light text-[#7A3E53] mb-8 leading-tight">
          We can't wait to say "I do" and then dance the night away with our favorite people—you!
        </h2>
        <p className="text-[#5A8E6E] leading-relaxed text-lg mb-8">
          Thank you for being part of our best day ever.
        </p>
        <div 
          ref={separatorRef}
          className={`h-px bg-[#F7C843] mx-auto my-10 transition-all duration-1000 ${
            separatorVisible 
              ? 'opacity-100 w-24' 
              : 'opacity-0 w-0'
          }`}
          style={{ transitionDelay: separatorVisible ? '400ms' : '0ms' }}
        ></div>
      </div>

      <div 
        ref={cardsRef}
        className={`grid md:grid-cols-2 gap-8 max-w-4xl mx-auto px-6 transition-all duration-1000 ${
          cardsVisible 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
        }`}
      >
        <div 
          className="p-8 border border-[#E76C9B]/20 rounded-2xl bg-white/80 shadow-sm hover:shadow-lg transition-all duration-300"
          style={{ transitionDelay: cardsVisible ? '200ms' : '0ms' }}
        >
          <Users className="mx-auto mb-5 text-[#E76C9B]" size={32} />
          <h3 className="text-xl font-serif font-light text-[#7A3E53] mb-3">RSVP</h3>
          <p className="text-[#5A8E6E] text-base mb-6">
            Kindly respond by Sunday, 30 November 2025
          </p>
          <button 
            onClick={() => setActiveSection('rsvp')}
            className="w-full bg-[#7A3E53] text-white py-3 px-6 rounded-full hover:bg-[#7A3E53]/90 hover:shadow-md transition-all duration-300 font-serif tracking-wide"
          >
            Respond Here
          </button>
        </div>

        <div 
          className="p-8 border border-[#F36C3D]/20 rounded-2xl bg-white/80 shadow-sm hover:shadow-lg transition-all duration-300"
          style={{ transitionDelay: cardsVisible ? '400ms' : '0ms' }}
        >
          <Gift className="mx-auto mb-5 text-[#F36C3D]" size={32} />
          <h3 className="text-xl font-serif font-light text-[#7A3E53] mb-3">Gift Registry</h3>
          <p className="text-[#5A8E6E] text-base mb-6">
            Your presence is our present
          </p>
          <button 
            onClick={() => setActiveSection('registry')}
            className="w-full bg-[#7A3E53] text-white py-3 px-6 rounded-full hover:bg-[#7A3E53]/90 hover:shadow-md transition-all duration-300 font-serif tracking-wide"
          >
            View Registry
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSection;